import '../src/base';
import '~/app/assets/javascripts/application/sitewide';
import '~/app/assets/javascripts/application/shared/map';
import '~/app/assets/javascripts/application/courses_public_universities/show';
